import {Controller} from '@hotwired/stimulus'

export default class extends Controller {
  static values = {content: String}

  copy(event) {
    event.stopPropagation()
    event.preventDefault()

    const button = event.currentTarget
    const original = button.textContent

    navigator.clipboard.writeText(this.contentValue).then(() => {
      button.textContent = button.dataset.copiedText || 'Copied!'
      button.classList.add('btn--copied')
      setTimeout(() => {
        button.textContent = original
        button.classList.remove('btn--copied')
      }, 2000)
    })
  }
}
